import Reveal from "@/components/Reveal";
import { ClipboardList, HandCoins, ConciergeBell, Wallet } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: ClipboardList,
    title: "Tell Us About Your Property",
    text: "Submit your property details so we can evaluate its short-term rental potential.",
  },
  {
    num: "02",
    icon: HandCoins,
    title: "Receive Your $500 Partnership Incentive",
    text: "Once your property qualifies and the partnership requirements are satisfied, you receive your $500 incentive according to our agreement.",
  },
  {
    num: "03",
    icon: ConciergeBell,
    title: "We Manage Your Rental",
    text: "Our team helps launch your listings, attract guests, handle reservations, and coordinate ongoing operations.",
  },
  {
    num: "04",
    icon: Wallet,
    title: "Keep 80% of Monthly Profits",
    text: "You receive 80% of the monthly profits, while Shonta Solutions earns 20% for managing the rental.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 sm:py-28 bg-white" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Simple Process</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            How Our Partnership Works
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08}>
              <article
                data-testid={`step-card-${step.num}`}
                className="group h-full bg-[#F7F7F9] border border-[#EBEBEB] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10)] hover:bg-white"
              >
                <div className="flex items-start justify-between">
                  <span className="font-heading text-5xl font-extrabold text-[#FFD3C6] group-hover:text-[#FF5A5F] transition-colors duration-300">
                    {step.num}
                  </span>
                  <span className="w-11 h-11 rounded-xl bg-white border border-[#EBEBEB] flex items-center justify-center group-hover:bg-[#FF5A5F] transition-colors duration-300">
                    <step.icon className="w-5 h-5 text-[#FF5A5F] group-hover:text-white transition-colors duration-300" />
                  </span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-[#222]">{step.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#5a5a5a]">{step.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
